import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Menu,
  MenuItem,
  TextField,
  TablePagination,
  InputAdornment,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate } from "react-router-dom";
import { projects, updateProject } from "../../apis/apisList/userApi";
import FileUploadDialog from "../adminDashboard/FileUploadDialog";
import { toast } from "react-toastify";
import CustomLoader from "../CustomLoader";
import { deleteProject } from "../../apis/apisList/adminApi";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { getChipProps, getUserStatusLable } from "../../config/helper";
export default function CustomTable({ title, userId }) {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const admin = localStorage.getItem("admin");
  const [uploadOpen, setUploadOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [projectDetail, setProjectDetail] = useState({});

  const getProjects = async () => {
    let query = {};
    if (userId) query.userId = userId;
    try {
      const { results } = await projects(query);
      setRows(results);
      setFilteredRows(results);
    } catch (error) {
      console.error(error);
      setRows([]);
      setFilteredRows([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getProjects();
  }, []);

  useEffect(() => {
    const filtered = rows.filter((row) =>
      row.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredRows(filtered);
  }, [searchTerm, rows]);

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleStatusChange = async (newStatus) => {
    if (selectedIndex !== null) {
      const updatedRows = [...rows];
      const selectedData = updatedRows[selectedIndex];
      try {
        await updateProject(selectedData._id, { status: newStatus });
        updatedRows[selectedIndex].status = newStatus;
        setRows(updatedRows);
      } catch (error) {
        console.error("Error updating project status:", error);
      }
    }
    setMenuAnchor(null);
    setSelectedIndex(null);
  };

  const cellStyle = {
    color: "#064776 !important",
    fontWeight: 600,
  };

  const handleDeleteProject = async (id) => {
    try {
      setIsDeleting(true);
      const response = await deleteProject(id);

      if (response?.success) {
        toast.success(response?.message);
        getProjects();
      } else {
        toast.error(response?.message);
      }
      setIsDeleting(false);
      setDeleteDialogOpen(false);
    } catch (error) {
      toast.error("Failed to delete project");
    } finally {
      setIsDeleting(false);
      setDeleteDialogOpen(false);
    }
  };

  if (loading) {
    return <CustomLoader loading={loading} />;
  }

  const onClose = () => {
    setDeleteDialogOpen(false);
  };
  return (
    <>
      {title && <Typography>{title}</Typography>}
      <TextField
        label="Search Projects"
        variant="outlined"
        margin="normal"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{
          float: "right",
          borderRadius: "10px",
          width: "250px",
          backgroundColor: "#fff",
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="disabled" />
            </InputAdornment>
          ),
          endAdornment: searchTerm && (
            <InputAdornment position="end">
              <IconButton onClick={handleClearSearch} size="small">
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <TableContainer
        component={Paper}
        sx={{ borderRadius: "10px", boxShadow: "none" }}
      >
        <Table
          sx={{
            width: "100%",
            "& thead": {
              backgroundColor: "#EBEBEB",
            },
            "& tbody": {
              backgroundColor: "#F8F8F8",
            },
            "& .MuiTableCell-root": {
              borderBottom: `1px solid #E0E0E0`,
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={cellStyle}>Project Name</TableCell>
              <TableCell sx={cellStyle}>Address</TableCell>
              {admin && <TableCell sx={cellStyle}>Client Name</TableCell>}
              <TableCell sx={cellStyle}>Date</TableCell>
              {admin && <TableCell sx={cellStyle}>Pricing</TableCell>}
              <TableCell sx={cellStyle}>Status</TableCell>
              {admin && <TableCell sx={cellStyle}>Action</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRows.length ? (
              filteredRows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow
                    key={row._id}
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        bgcolor: "#80808014",
                      },
                    }}
                  >
                    <TableCell
                      style={{
                        maxWidth: "400px",
                      }}
                      onClick={() => {
                        navigate(
                          admin
                            ? `/admindashboard/project/${row._id}`
                            : `/dashboard/project/${row._id}`
                        );
                      }}
                    >
                      {row.name}
                    </TableCell>
                    <TableCell
                      style={{
                        maxWidth: "400px",
                      }}
                    >
                      {row.address || "N/A"}
                    </TableCell>
                    {admin && (
                      <TableCell>{row.contact.fullName || "N/A"}</TableCell>
                    )}
                    <TableCell
                      style={{
                        width: "150px",
                      }}
                    >
                      {row.date || "N/A"}
                    </TableCell>
                    {admin && <TableCell>${row.price || "N/A"}</TableCell>}
                    <TableCell
                      onClick={(event) => {
                        if (admin) {
                          setMenuAnchor(event.currentTarget);
                          setSelectedIndex(index);
                        }
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          {row.isDraft === true ? (
                            <Chip
                              label="Draft"
                              size="small"
                              variant="outlined"
                              style={{ textTransform: "capitalize" }}
                            />
                          ) : (
                            <Chip
                              label={getUserStatusLable(
                                row.status,
                                row.userStatus
                              )}
                              variant="outlined"
                              size="small"
                              sx={{
                                textTransform: "capitalize",
                              }}
                              onDelete={admin ? () => {} : undefined}
                              deleteIcon={
                                admin ? <ArrowDropDownIcon /> : undefined
                              }
                              {...getChipProps(row.status, row.userStatus)}
                            />
                          )}
                        </div>
                      </div>
                    </TableCell>
                    {admin && (
                      <TableCell>
                        <Button
                          variant="contained"
                          color="error"
                          onClick={() => {
                            setDeleteDialogOpen(true);
                            setProjectDetail(row);
                          }}
                          disabled={row?.deletedAt}
                        >
                          {row?.deletedAt ? "Archived" : "Delete"}
                        </Button>
                      </TableCell>
                    )}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={7}>No projects found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={filteredRows.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <FileUploadDialog
        open={uploadOpen}
        onClose={onClose}
        projectId={filteredRows?.[selectedIndex]?._id}
      />

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
      >
        {/* <MenuItem onClick={() => handleStatusChange("pending")}>
          Pending
        </MenuItem> */}
        <MenuItem onClick={() => handleStatusChange("accepted")}>
          Accepted
        </MenuItem>
        <MenuItem onClick={() => handleStatusChange("rejected")}>
          Rejected
        </MenuItem>
        <MenuItem onClick={() => handleStatusChange("completed")}>
          Complete
        </MenuItem>
      </Menu>

      <Dialog
        open={deleteDialogOpen}
        onClose={() => {
          setDeleteDialogOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Delete Project Confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete project "{projectDetail?.name}"?
            This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDeleteProject(projectDetail._id);
            }}
            color="error"
            variant="contained"
            disabled={isDeleting}
            startIcon={
              isDeleting ? <CircularProgress size={20} color="inherit" /> : null
            }
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
